import { useSchema } from "../context/SchemaContext";

export type SchemaKey = string;

export function resolveSchemaStatic(schemaObj: any, schema: any): any {
  if (schema?.$ref) {
    const refName = schema.$ref.replace("#/components/schemas/", "");
    const target = schemaObj.components.schemas[refName];
    return resolveSchemaStatic(schemaObj, target);
  }
  return schema;
}

export function hasProperties(schema: unknown): schema is { properties: Record<string, any> } {
  return typeof schema === "object" && schema !== null && "properties" in schema;
}

export const getDisplayEventName = (eventSchemaName: string): string => {
  return eventSchemaName.substring(eventSchemaName.lastIndexOf(".") + 1);
};

export function useResolveSchema() {
  const { schema } = useSchema();
  return (schemaToResolve: any): any => {
    if (!schema) return null;
    return resolveSchemaStatic(schema, schemaToResolve);
  };
}

export function useEventKeys(eventsPrefix: string): SchemaKey[] {
  const { schema } = useSchema();
  if (!schema) return [];
  return Object.keys(schema.components.schemas).filter((key) => key.startsWith(eventsPrefix));
}
